import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { clearTsrAdminToken } from '../../auth/tsrAdminAuth';

function TsrAdminHomePage() {
  const navigate = useNavigate();

  const handleLogout = () => {
    clearTsrAdminToken();
    navigate('/tsr-admin', { replace: true });
  };

  return (
    <div className="tsr-admin-shell">
      <aside className="tsr-admin-sidebar p-3">
        <h5 className="mb-4">TSR Admin</h5>
        <nav className="d-flex flex-column">
          <NavLink to="/tsr-admin/home" end>Home</NavLink>
          <NavLink to="/tsr-admin/create-package">Packages</NavLink>
          <NavLink to="/tsr-admin/menu-items">Menu Items</NavLink>
          <NavLink to="/tsr-admin/coupons">Coupon Configuration</NavLink>
        </nav>
        <button type="button" className="btn btn-sm btn-outline-light mt-4" onClick={handleLogout}>
          Logout
        </button>
      </aside>
      <main className="tsr-admin-main">
        <Outlet />
      </main>
    </div>
  );
}

export default TsrAdminHomePage;
